import {
  GET_CATEGORY_FINANCE,
  GET_CATEGORY_FINANCE_ORGANIZED,
  CREATE_CATEGORY_FINANCE,
  DELETE_CATEGORY_FINANCE,
  UPDATE_CATEGORY_FINANCE,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_CATEGORIES_FINANCE_SELECT,
} from "./actionType";

const INIT_STATE = {
  categoryFinance: {
    D: [],
    R: [],
  },
  categoryFinanceSelect: [],
  categoryFinanceOrganized: [],
  error: {},
  success: "",
};

const CategoryFinance = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CATEGORY_FINANCE:
          return {
            ...state,
            categoryFinance: action.payload.data,
            success: "",
            error: {},
          };
        case GET_CATEGORY_FINANCE_ORGANIZED:
          return {
            ...state,
            categoryFinanceOrganized: action.payload.data,
            success: "",
            error: {},
          };
        case GET_CATEGORIES_FINANCE_SELECT:
          return {
            ...state,
            categoryFinanceSelect: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "Successfully created category finance",
            error: {},
          };
        case UPDATE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "Successfully updated category finance",
            error: {},
          };
        case DELETE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "Successfully delete category finance",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CATEGORY_FINANCE:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
          case GET_CATEGORY_FINANCE_ORGANIZED:
            return {
              ...state,
              success: "",
              error: action.payload.error,
            };
        case CREATE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case GET_CATEGORIES_FINANCE_SELECT:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_CATEGORY_FINANCE:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_CATEGORY_FINANCE: {
      return {
        ...state,
      };
    }
    case GET_CATEGORY_FINANCE_ORGANIZED: {
      return {
        ...state,
      };
    }
    case CREATE_CATEGORY_FINANCE: {
      return {
        ...state,
      };
    }
    case UPDATE_CATEGORY_FINANCE: {
      return {
        ...state,
      };
    }
    case DELETE_CATEGORY_FINANCE: {
      return {
        ...state,
      };
    }
    case GET_CATEGORIES_FINANCE_SELECT:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default CategoryFinance;
